<template>
  <span @click.stop="copy" class="copy py-1 px-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
      <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
        <path d="M8.5,3.5v-1a1,1,0,0,0-1-1h-1" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></path>
        <path d="M4,10.5H1.5a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1h1" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></path>
        <rect x="6.5" y="5.5" width="7" height="8" rx="1" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></rect>
        <path d="M6.75.5H2.25l.41,1.62a.49.49,0,0,0,.48.38H5.86a.49.49,0,0,0,.48-.38Z" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></path>
        <line x1="8.5" y1="8.5" x2="11.5" y2="8.5" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></line>
        <line x1="8.5" y1="10.5" x2="11.5" y2="10.5" style="fill: none;stroke: #999999;stroke-linecap: round;stroke-linejoin: round"></line>
      </g></g>
    </svg>

    <slot></slot>
  </span>
</template>

<script>

export default {
  props: {
    value: String,
    skeletonClass: String,
    message: {
      type: String,
      default: "Succesvol naar het klembord gekopieerd!",
    },
  },
  methods: {
    async copy() {
      try {
      await navigator.clipboard.writeText(this.value)
      this.$success(this.message)
    } catch(err) {}
    },
  },
}

</script>

<style scoped>

.copy {
  display: inline-block;
  cursor: copy !important;
  border-radius: 1px;
  border: 1px solid transparent;
}

.copy:hover {
  border: 1px solid rgba(153, 153, 153, .3);
}

</style>
